import { createStore } from 'vuex'

const store = createStore({
  state () {
    return {
      // webBaseUrl: process.env.NODE_ENV == 'production' ? 'https://sdbox-m.taoshouyou.com' : 'http://t2-webapp.taoshouyou.com',
      // gameBaseUrl: process.env.NODE_ENV == 'production' ? 'https://9.taoshouyou.com' : 'http://t1-game.taoshouyou.com',
      // 生产环境
      webBaseUrl: 'https://m.taoshouyou.com',
      gameBaseUrl: 'https://9.taoshouyou.com',
      // 测试环境
      // webBaseUrl: 'http://t2-webapp.taoshouyou.com',
      // gameBaseUrl: 'http://t0-game.taoshouyou.com',
      isWeixin: false,
      shareCommand: '',
      searchData: {}
    }
  },
  mutations: {
    isWeixin (state, payload) {
      state.isWeixin = payload
    },
    shareCommand (state, payload) {
      state.shareCommand = payload
    },
    searchData (state, payload) {
      state.searchData = payload
    }
  }
})

export default store
